<template>
  <span v-text="value"> </span>
</template>
<script>
import get from "lodash/get";
import { formartedPathName } from "./prepareItem";
export default {
  name: "formatedRow",
  props: {
    name: { type: String, required: true },
    item: { type: Object, required: true },
  },

  computed: {
    value() {
      return get(this.item, formartedPathName(this.name), get(this.item, this.name));
    },
  },
};
</script>
